import { useEffect } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import {
  ReactSelectInput,
  getReactSelectValue,
} from '@hivebrite/design-system/Inputs';

import {
  MOBILE_VALUE_MODES,
  convertResponsivenessValues,
} from 'hb-builder/components/BuilderComponents/single/Headline/utils/settings';
import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import ThemeProvider from 'hb-react/style/ThemeProvider';

const options = [
  { value: MOBILE_VALUE_MODES.AUTO, label: __('Auto') },
  { value: MOBILE_VALUE_MODES.CUSTOM, label: __('Custom') },
];

const SelectMobileValueMode = ({
  item,
  onChange,
  mobileValueMode,
  setMobileValueMode,
}) => {
  const handleChangeResizeMode = (e) => {
    setMobileValueMode(e.value);
    onChange({
      id: item.id,
      settingKey: 'attributes.isCustomMobileValue',
      value: e.value === MOBILE_VALUE_MODES.CUSTOM,
    });
  };

  const valueSelected = getReactSelectValue(options, mobileValueMode);

  useEffect(() => {
    const convertResponsiveAttributes = () => {
      const fontSizeBreakpoints = item.attributes.headlineFontSize;
      const lineHeightBreakpoints = item.attributes.headlineLineHeight;

      // l & xl have the same value
      const fontSizeResponsiveValue = convertResponsivenessValues(
        fontSizeBreakpoints.l,
      );
      const lineHeightResponsiveValue = convertResponsivenessValues(
        lineHeightBreakpoints.l,
      );

      onChange({
        id: item.id,
        values: [
          {
            settingKey: 'attributes.headlineFontSize',
            value: {
              ...fontSizeBreakpoints,
              s: fontSizeResponsiveValue,
              m: fontSizeResponsiveValue,
            },
          },
          {
            settingKey: 'attributes.headlineLineHeight',
            value: {
              ...lineHeightBreakpoints,
              s: lineHeightResponsiveValue,
              m: lineHeightResponsiveValue,
            },
          },
        ],
      });
    };

    if (mobileValueMode === MOBILE_VALUE_MODES.AUTO) {
      // If mode auto, converts desktop values to mobile and tablet
      convertResponsiveAttributes();
    }
    // Skip item.attributes value to avoid infinite loop
  }, [mobileValueMode, item.id, onChange]);

  return (
    <Box mb={4} justifyContent="space-between">
      {/* Add theme provider to have the right breakpoints for tooltip */}
      <ThemeProvider theme="bo" builderDisableStyledSystemCache>
        <InputTitle
          id="isCustomMobileValue-input"
          label={__('Resize mode')}
          position="left"
          tooltip={s__(
            'Builder|Your headline adjusts automatically for mobile. For further customization, switch to custom mode.',
          )}
          tooltipPosition="RIGHT"
        />
      </ThemeProvider>
      <ReactSelectInput
        ariaLabel={__('Resize mode')}
        dataTestId="builder-headline-mobile-value-mode"
        id="builder-headline-isCustomMobileValue"
        name="isCustomMobileValue"
        onChange={handleChangeResizeMode}
        options={options}
        value={valueSelected}
        variant="small"
        width={155}
      />
    </Box>
  );
};

export default SelectMobileValueMode;
